<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>机器人管理</span>
          <clear-cache-apply />
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="ID" label="ID">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="uid" label="用户ID">
            <template slot-scope="scope">
              <span>{{ scope.row.uid }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="nick" label="昵称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.nick" placeholder="昵称" />
            </template>
          </el-table-column>
          <el-table-column prop="level" label="等级">
            <template slot-scope="scope">
              <el-input v-model="scope.row.level" placeholder="等级" />
            </template>
          </el-table-column>
          <el-table-column prop="star" label="星星">
            <template slot-scope="scope">
              <el-input v-model="scope.row.star" placeholder="星星" />
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="60px">
            <template slot-scope="scope">
              <span>{{ scope.row.sex }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="avatar" label="头像" width="300px">
            <template slot-scope="scope">
              <!--              <span>{{ scope.row.avatar }}</span>-->
              <el-input v-model.trim="scope.row.avatar" placeholder="昵称" />
            </template>
          </el-table-column>
          <!--          <el-table-column prop="mac" label="设备ID">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-input v-model.number="scope.row.mac" placeholder="用户OD" />-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <el-select v-model="scope.row.type" placeholder="请选择">
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="is_run" label="启动状态">
            <template slot-scope="scope">
              <el-select v-model="scope.row.is_run" placeholder="请选择">
                <el-option
                  v-for="item in runType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-permisaction="['config:robot:del']" style="margin-top: 10px" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:robot:add']" style="margin-top: 10px" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:robot:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>

        <!--        <el-form :inline="true" class="demo-form-inline">-->
        <!--          <el-row v-for="(item, index) in formData" :key="index">-->
        <!--            <el-form-item label="ID">-->
        <!--              <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="ID" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="用户ID">-->
        <!--              <el-input v-model.number="item.uid" style="width: 100px;" placeholder="用户OD" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="设备ID">-->
        <!--              <el-input v-model="item.mac" style="width: 150px;" placeholder="设备ID" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="类型">-->
        <!--              <el-select v-model="item.type" placeholder="请选择">-->
        <!--                <el-option-->
        <!--                  v-for="item in types"-->
        <!--                  :key="item.value"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--                />-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="启动状态">-->
        <!--              <el-select v-model="item.is_run" placeholder="请选择">-->
        <!--                <el-option-->
        <!--                  v-for="item in runType"-->
        <!--                  :key="item.value"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--                />-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="创建时间">-->
        <!--              <el-input v-model="item.created_at" readonly style="width: 200px;" placeholder="创建时间" />-->
        <!--            </el-form-item>-->
        <!--          </el-row>-->
        <!--          <el-form-item>-->
        <!--          </el-form-item>-->
        <!--        </el-form>-->

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { addRobot, delRobot, getRobot, updateRobot } from '@/api/config/robot'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
export default {
  name: 'Robot',
  components: { ClearCacheApply },
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      // ：0普通，1平衡，2激进
      types: [{
        value: 0,
        label: '普通'
      }, {
        value: 1,
        label: '平衡'
      }, {
        value: 2,
        label: '激进'
      }],
      runType: [{
        value: 0,
        label: '关闭'
      }, {
        value: 1,
        label: '启动'
      }],
      formData: [
        {
          'id': 0,
          'uid': 0,
          'type': 0,
          'mac': '',
          'is_run': 0,
          'avatar': '',
          'created_at': 0,
          'level': 0,
          'star': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateRobot({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getRobot(this.queryParams).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      addRobot().then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delRobot({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
